import { type TFunction } from "i18next";

export enum FlightPassengersKeyEnum {
  CLASS = "CLASS",
  ADULTS = "ADULTS",
  CHILDREN = "CHILDREN",
  INFANT = "INFANT",
}

export enum FlightPassengersTypeEnum {
  CLASS = "CLASS",
  GUEST = "GUEST",
}

export enum FlightPassengersConditionEnum {
  PLUS = "PLUS",
  MINUS = "MINUS",
  CLASS = "CLASS",
}
export interface FlightPassengersValueInterface {
  key: FlightPassengersKeyEnum;
  title: string;
  minValue: number;
  maxValue?: number;
  currentValue: number | string;
  type: FlightPassengersTypeEnum;
  icon?: string;
  ageLength?: string;
  flightClassData?: {
    langKey: string;
    mapKey: string;
  }[];
}

export interface SubChildrenValues {
  keyParent: FlightPassengersKeyEnum;
  key: number;
  value: number;
}
export interface FlightClassDataInterface {
  langKey: string;
  mapKey: string;
}
export const classOfFlight = [
  "Economy",
  "Premium Economy",
  "Business",
  "First",
];
export enum CabinClassEnum {
  Y = "Y",
  W = "W",
  J = "J",
  F = "F",
}
export const bookingClassDeparture = ["Y", "W", "J", "F"];
export enum BookingClassName {
  "Y" = "economy_class",
  "J" = "bussiness_class",
  "W" = "premium_economy_class",
  "F" = "first_class",
}
// Y – Economy Class
// W - Premium Economy Class
// J – Business Class
// F – First Class

export const getFlightClassData = (
  t: TFunction<string, undefined>,
): FlightClassDataInterface[] => [
  { langKey: t?.("flightClassType.economyClass") || "", mapKey: "Y" },
  { langKey: t?.("flightClassType.businessClass") || "", mapKey: "J" },
  {
    langKey: t?.("flightClassType.premiumEconomyClass") || "",
    mapKey: "W",
  },
  { langKey: t?.("flightClassType.firstClass") || "", mapKey: "F" },
];
